import React, { ChangeEvent, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styles from './popup.module.scss';
import { Button, Textarea, Typography } from '@/ui-kit';
import { FieldBlock } from '@/components/field-block';
import { useTranslation } from 'react-i18next';

interface Props {
    textPlans: string;
    isSignUp?: boolean,
    onSubmit?: (plans: string) => void;
    onClose: () => void;
}

export const TravelPlans: React.FC<Props> = ({
    textPlans,
    isSignUp = false,
    onSubmit,
    onClose,
}) => {
    const [plans, setPlans] = useState(textPlans);
    const [isPlaceholderShown, setPlaceholderShown] = useState<boolean>(isSignUp)

    useEffect(() => {
        setPlans(textPlans);
    }, [textPlans]);

    const handleSubmit = useCallback(
        (e: React.FormEvent) => {
            e.preventDefault();

            if (plans.length <= 0 || plans.length > 500) return;

            if (onSubmit) {
                onSubmit(plans);
            }
        },
        [plans, onSubmit],
    );

    const handleChangeTextArea = useCallback((e: ChangeEvent<HTMLTextAreaElement>) => {
        setPlans(e.target.value);
    }, []);

    const isDisabled = useMemo(
        () => {
            const len = plans
                .trim()
                .length
            const isLenInvalid = len <= 0 ||
                len > 500
            const isSame = plans === textPlans
            return isLenInvalid ||
                isSame
        },
        [plans]
    );

    const { t } = useTranslation();

    return (
        <div className={styles.editFormPlans}>
            <form onSubmit={handleSubmit}>
                <FieldBlock>
                    <div className={styles.formLabel}>
                        <Typography
                            variant="label"
                            fontWeight="semibold">
                            {t('travel_plans_label')}
                        </Typography>
                    </div>
                    <Textarea
                        id="travel-place-input"
                        maxLength={500}
                        height={100}
                        placeholder={
                            isPlaceholderShown || !isSignUp ?
                                t('travel_plans_placeholder')
                            : ''
                        }
                        defaultValue={plans}
                        onChange={handleChangeTextArea}
                        onClick={() => setPlaceholderShown(false)} />
                    <div id="travel-place-input-anchor" style={{ width: 'min-content' }} />
                </FieldBlock>
                <Button
                    type="submit"
                    variant="stretched"
                    typeColor="orange"
                    isDisabled={isDisabled}>
                    {t('apply')}
                </Button>
            </form>

            <Button
                variant="stretched"
                typeColor="white"
                onClick={onClose}>
                {t('cancel')}
            </Button>
        </div>
    );
};
